import { useState, useEffect, useCallback } from "react";
import { api } from "../lib/api";

// The home dashboard. One request: the Business Review Service reads every table the
// page needs from the shared database, so the screen paints once rather than in pieces.
//
// A metric the server could not compute — its table or column is missing on this
// database — comes back as null, and the screen shows "—" for it rather than a zero.
export function useDashboard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    try {
      setData(await api.get("s4/api/dashboard"));
      setError("");
    } catch (e) {
      setError(e.message || "Could not load the dashboard.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return { data, loading, error, reload: load };
}
